import { ethers } from 'ethers';

export const verifyAddressesMatch = (address, otherAddress) => {
  if (!address || !otherAddress) return false;

  try {
    const checksummedAddress = getChecksummedAddress(address);
    const checksummedOtherAddress = getChecksummedAddress(otherAddress);
    return checksummedAddress === checksummedOtherAddress;
  } catch (e) {
    return false;
  }
};

export const getChecksummedAddress = address => {
  return ethers.utils.getAddress(address);
};
